import React from 'react'
import { Modal, Typography, Icon } from '@ann/web-components';
import {
	ModalHeaderContainer,
	CustomModalContainer,
	DocumentWrapper,
	DocumentRemoveFileWrapper,
	CustomModalRemoveContainer
} from './Modals.styled';

const RemoveAccessModal = ({isOpen, onClose}) => {
	
	const handleConfirmData = () => {
		console.log('manage access');
	}
	
	return (
		<CustomModalContainer>
			<Modal isOpen={isOpen} onClose={onClose} size="medium">
				<Modal.Header/>
				<ModalHeaderContainer>
					<Typography category="title" size="medium" weight="bold">
						Are you sure you want to delete this file?
					</Typography>
				</ModalHeaderContainer>
				<Modal.Body>
					<CustomModalRemoveContainer>
							<Typography category="body" size="medium" weight="regular" color="body">
								This action will permanently remove the selected file from your agent’s knowledge base.
							</Typography>
						<DocumentRemoveFileWrapper>
							<DocumentWrapper>
								<Icon name="description" />
								<Typography category="body" size="medium" weight="regular" color="body">
									Document-name.pdf
								</Typography>
							</DocumentWrapper>
						</DocumentRemoveFileWrapper>
					</CustomModalRemoveContainer>
				</Modal.Body>
				<Modal.Actions align="center">
					<Modal.Button label="Cancel" onClick={onClose} type="secondary"/>
					<Modal.Button label="Delete" onClick={handleConfirmData}/>
				</Modal.Actions>
			</Modal>
		</CustomModalContainer>
	)
}

export default RemoveAccessModal
